import React, { useState } from 'react';
import { TemplateAddOnList } from './TemplateAddOnList';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { gAPI_CopyAddOn } from '../../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';

function TemplateAddOnButton({ propertyId, LoadData }) {
    const [visible, setVisible] = useState(false);
    const handleSubmit = data => {
        AxiosAPI({
            method: 'post',
            url: `${gAPI_CopyAddOn}`,
            data,
        })
            .then(
                res => {
                    setVisible(!visible)
                    LoadData();
                }
            )
            .catch(err => {
                console.log('err', err);
            });
    };

    return (
        <div>
            <Button
                color="primary"
                outline
                size="lg"
                onClick={() => {
                    setVisible(!visible);
                }}
                style={{ width: '100%', borderRadius: '6px' }}
            >
                + Add From Templates
      </Button>

            <TemplateAddOnList
                formLabel="Template Addon List"
                visible={visible}
                toggle={() => {
                    setVisible(!visible);
                }}
                submit={handleSubmit}
                propertyId={propertyId}
            />
        </div>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId,
    };
};

export default injectIntl(connect(mapStateToProps, {})(TemplateAddOnButton));

TemplateAddOnButton.propTypes = {
    propertyId: PropTypes.string.isRequired,
};
